export default __webpack_public_path__ + "static/media/evichatLogo.e56a8714.svg";